syntax = "proto2";

package com.scalableminds.webknossos.datastore;

message ListOfLong {
  repeated uint64 items = 1;
}
